import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RadioGroupComponent } from '@app/shared/components/radio-buttons/radio-group/radio-group.component';
import { RadioButtonComponent } from '@app/shared/components/radio-buttons/radio-button/radio-button.component';
import { RadioGroupItemComponent } from '@app/shared/components/radio-buttons/radio-buttons-item/radio-group-item.component';
import { RadioGroupItemIconComponent } from '@app/shared/components/radio-buttons/radio-button-item-icon/radio-group-item-icon.component';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RadioGroupComponent,
    RadioButtonComponent,
    RadioGroupItemComponent,
    RadioGroupItemIconComponent,
  ],
  exports: [RadioGroupComponent, RadioButtonComponent, RadioGroupItemComponent, RadioGroupItemIconComponent],
})
export class RadioButtonsModule {}
